import { Form, Input, Row, Col, Switch, DatePicker, Select, Tooltip } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import moment from 'moment';
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../universal/getList';
import dayjs from 'dayjs';

//布局
const layout = {
    // labelCol: { span: 8 },
    // wrapperCol: { span: 16 }, 
};

const WebCarouselAdEdit = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { editMode, editingId } = props;
    const ref = useRef<any>(undefined);
    const [adShowModelData, setAdShowModelData] = useState<any>();
    const [carouselAdTypeData, setCarouselAdTypeData] = useState<any>();
    /** 后端数据defaultService */
    let defaultService: any = '';

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            defaultService = ref.current.defaultService;
        }
        const fetchData = async () => {
            fetchApi.GET(defaultService,
                {
                    apiId: 'generalData',
                    apiVariable: 'adShowModel',
                    apiExtend: 'showList'
                }).then(res => {
                    if (res.success) {
                        setAdShowModelData(res.data);
                    }
                })
            fetchApi.GET(defaultService,
                {
                    apiId: 'generalData',
                    apiVariable: 'carouselAdType',
                    apiExtend: 'showList'
                }).then(res => {
                    if (res.success) {
                        setCarouselAdTypeData(res.data);
                    }
                })
        };
        fetchData();
    }, []);

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        data: {
            type: editMode,
            id: editingId
        },
        ...props,
        form,
        apiId: 'webCarouselAd',
        dateColumnName: ['startTime', 'endTime'],
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(editMode === 'NEW' ? '新增' : '编辑') + '图片广告'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}>

                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyPress={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>

                    <Row gutter={[8, 0]}>
                        <Col span={6}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="名称"
                                name="adName"
                                rules={[{ required: true, message: '广告名称!' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="类型"
                                name="carouselAdTypeId">
                                <Select
                                    showSearch
                                    placeholder="类型"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(carouselAdTypeData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="说明"
                                name="contents">
                                <Input.TextArea
                                    placeholder="说明"
                                    rows={4}>
                                </Input.TextArea>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="开始时间"
                                name="startTime"
                                initialValue={dayjs()}>
                                <DatePicker
                                    format="YYYY-MM-DD HH:mm:ss"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="结束时间"
                                name="endTime"
                                initialValue={dayjs()}>
                                <DatePicker
                                    format="YYYY-MM-DD HH:mm:ss"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="显示总数"
                                name="showCounts">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="剩余数"
                                name="remainingShows">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={7}>
                            <Form.Item
                                label="显示模式"
                                name="adShowModelId">
                                <Select
                                    showSearch
                                    placeholder="显示模式"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(adShowModelData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Tooltip placement="topLeft"
                                title={'当选项为是，所有产品详情页会附加此广告，但类型必须是[图片]'}>
                                <Form.Item
                                    label="产品广告"
                                    name="isProductAd"
                                    valuePropName="checked"
                                    initialValue={true}>
                                    < Switch checked={true}
                                        checkedChildren="是"
                                        unCheckedChildren="否" />
                                </Form.Item>
                            </Tooltip>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default WebCarouselAdEdit;